import { Tag, Tooltip } from '@vtbhome/juicyfront';
import { styled } from 'goober';
import { ReactNode } from 'react';

export const StyledTooltip = styled(Tooltip)<{ children: ReactNode }>`
    width: fit-content;
`;

export const StyledTag = styled(Tag)<{ children: ReactNode }>`
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    width: fit-content;

    .rf-tag__icon {
        display: flex;
        margin-left: 4px !important;
        margin-right: 0 !important;
        align-items: center;
    }
`;

export const TooltipDeclineBody = styled('div')`
    display: flex;
    max-width: 420px;
    flex-direction: column;
    gap: 8px;
`;
